import { render } from "./JumbotronBox.vue?vue&type=template&id=1eb2db96&scoped=true"
import script from "./JumbotronBox.vue?vue&type=script&lang=js"
export * from "./JumbotronBox.vue?vue&type=script&lang=js"

import "./JumbotronBox.vue?vue&type=style&index=0&id=1eb2db96&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb2db96"]])

export default __exports__